import { useCallback, useRef } from 'react';
import { useDebounce } from '../useDebounce';
import { moveIndexInTwoDimension, } from './moveIndexInTwoDimension';
/**
 * use keyboard move index in two dimensional
 */
export var useKeyboardMoveFocus = function (_a) {
    var infinite = _a.infinite, _b = _a.options, options = _b === void 0 ? [] : _b, focusedIndexRef = _a.focusedIndexRef, onFocusedIndexChange = _a.onFocusedIndexChange, getOptionDisabled = _a.getOptionDisabled, getOptionSearchText = _a.getOptionSearchText, _c = _a.columns, columns = _c === void 0 ? 1 : _c, _d = _a.endSearchDebounceTime, endSearchDebounceTime = _d === void 0 ? 500 : _d;
    var total = options.length;
    var searchText = useRef('');
    var debounceEndSearch = useDebounce(function () { return (searchText.current = ''); }, endSearchDebounceTime);
    var searchTextAndFocus = function (event) {
        var key = event.key;
        if (!getOptionSearchText || key.length !== 1)
            return;
        debounceEndSearch();
        searchText.current += key.toLowerCase();
        var matchedIndex = options.findIndex(function (option) {
            var text = getOptionSearchText(option);
            return Boolean(!(getOptionDisabled === null || getOptionDisabled === void 0 ? void 0 : getOptionDisabled(option)) &&
                text &&
                text.toLowerCase().startsWith(searchText.current));
        });
        if (matchedIndex > -1) {
            onFocusedIndexChange(event, matchedIndex);
        }
    };
    var onKeyFocusedIndexHandle = function (event) {
        var currIndex = focusedIndexRef.current;
        var key = event.key;
        var findDirection;
        if (total === 0)
            return;
        // eslint-disable-next-line no-constant-condition
        while (true) {
            var toIndex = findDirection
                ? findDirection === 'next'
                    ? currIndex + 1
                    : currIndex - 1
                : moveIndexInTwoDimension(key, {
                    currIndex: currIndex,
                    columns: columns,
                    total: total,
                    infinite: infinite,
                });
            if (toIndex === currIndex) {
                searchTextAndFocus(event);
                break;
            }
            if (!(getOptionDisabled === null || getOptionDisabled === void 0 ? void 0 : getOptionDisabled(options[toIndex]))) {
                if (toIndex !== focusedIndexRef.current) {
                    onFocusedIndexChange(event, toIndex);
                }
                break;
            }
            // * mean that item is disabled, use same direction find next
            else {
                // * find toIndex is same as current, mean that already find all
                if (focusedIndexRef.current !== -1 &&
                    toIndex === Math.max(focusedIndexRef.current, 0)) {
                    break;
                }
                currIndex = toIndex;
                // * if that is Hom or End, find use increase or decrease
                if (key === 'Home') {
                    findDirection = 'next';
                }
                else if (key === 'End') {
                    findDirection = 'prev';
                }
            }
        }
    };
    var getPrevFocusableOption = useCallback(function (index, 
    /** is that infinite search */
    isInfinite) {
        if (index === void 0) { index = focusedIndexRef.current; }
        if (isInfinite === void 0) { isInfinite = true; }
        for (var i = index; i >= 0; i--) {
            if (!(getOptionDisabled === null || getOptionDisabled === void 0 ? void 0 : getOptionDisabled(options[i]))) {
                return i;
            }
        }
        if (isInfinite) {
            // loop find
            for (var i = total - 1; i > index; i--) {
                if (!(getOptionDisabled === null || getOptionDisabled === void 0 ? void 0 : getOptionDisabled(options[i]))) {
                    return i;
                }
            }
        }
        return -1;
    }, [focusedIndexRef, getOptionDisabled, options, total]);
    var getNextFocusableOption = useCallback(function (index, 
    /** is that infinite search */
    isInfinite) {
        if (index === void 0) { index = focusedIndexRef.current; }
        if (isInfinite === void 0) { isInfinite = true; }
        for (var i = index; i < total; i++) {
            if (!(getOptionDisabled === null || getOptionDisabled === void 0 ? void 0 : getOptionDisabled(options[i]))) {
                return i;
            }
        }
        if (isInfinite) {
            // loop find
            for (var i = 0; i < index; i++) {
                if (!(getOptionDisabled === null || getOptionDisabled === void 0 ? void 0 : getOptionDisabled(options[i]))) {
                    return i;
                }
            }
        }
        return -1;
    }, [focusedIndexRef, getOptionDisabled, options, total]);
    return {
        /**
         * Get previous focusable option(include current index).
         */
        getPrevFocusableOption: getPrevFocusableOption,
        /**
         * Get next focusable option(include current index).
         */
        getNextFocusableOption: getNextFocusableOption,
        /**
         * Use to handle keyboard event.
         */
        onKeyFocusedIndexHandle: onKeyFocusedIndexHandle,
    };
};
